module.exports = "/lucky-balls/img/loading.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/loading.png
// module id = 1121
// module chunks = 0